var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.922,
    height: 21.566,
    viewBox: "0 0 19.922 21.566",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_23840",
    "data-name": "Path 23840",
    d: "M23.795,13.586,6.589,4.147a1.348,1.348,0,0,0-1.955,1.2v7.524a.661.661,0,0,0,.566.661l13.943,1.254-14,1.254a.661.661,0,0,0-.566.661v7.524a1.348,1.348,0,0,0,1.955,1.2l17.206-9.439a1.348,1.348,0,0,0,.054-2.4Z",
    transform: "translate(-4.58 -4.003)",
    fill: "#E10092"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.4557a7ceb97d106908b5b482058aa3d3.svg";
export { ForwardRef as ReactComponent };